export default function Privacy() {
  return (
    <div className="page-shell px-4 py-14 sm:px-6">
      <div className="mx-auto max-w-4xl">
        <h1 className="mb-8 text-center text-4xl font-extrabold text-secondary">Privacy Policy</h1>
        
        <p className="mb-8 text-center italic text-textMuted">
          Last updated: June 19, 2026
        </p>

        <div className="ui-card divide-y divide-slate-100 px-6 py-3 sm:px-10">
          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">1. Introduction</h2>
            <p className="mb-4 text-textMuted">
              DeCipher ("we", "us", or "our") values your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website, services, and associated applications (collectively, the "Service").
            </p>
            <p className="text-textMuted">
              By accessing or using the Service, you consent to the data practices described in this policy. If you do not agree with any part of this policy, please do not use the Service.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">2. Information We Collect</h2>
            <p className="mb-4 text-textMuted">
              We collect information that you provide directly to us when creating an account, adjusting profile configurations, or completing transactions. This includes your name, email address, and authentication credentials.
            </p>
            <p className="text-textMuted">
              <strong className="text-secondary">Third-Party Integrations & API Data:</strong> If you choose to link third-party social accounts to our platform (such as through the TikTok Login Kit), we collect basic profile metadata provided via the platform's API permissions. We do not store or track your raw account passwords.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">3. How We Use Your Information</h2>
            <p className="mb-4 text-textMuted">
              We utilize the information we collect to manage, maintain, and optimize your experience on our platform. This includes:
            </p>
            <p className="text-textMuted">
              - Authenticating account access and verifying user identities.<br />
              - Executing programmatic operations, such as publishing video assets via official platform APIs.<br />
              - Processing subscription payments safely through our payment processors.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">4. Data Sharing and Third Parties</h2>
            <p className="mb-4 text-textMuted">
              We do not sell, rent, or trade your personal information to third parties for marketing purposes.
            </p>
            <p className="text-textMuted">
              Data is only shared with third-party infrastructure providers necessary to fulfill your requests. This includes Stripe for secure payment processing and social network API channels (like TikTok's Content Posting API) to securely stream video files directly to your connected profiles.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">5. Data Retention and Security</h2>
            <p className="mb-4 text-textMuted">
              We retain your data only for as long as necessary to fulfill the core operational requirements of your active account. We implement robust, industry-standard administrative and technical security layers to shield your personal data from unauthorized access or alteration.
            </p>
            <p className="text-textMuted">
              You can revoke API access tokens or delete your account credentials at any point directly within your dashboard settings.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">6. Your Rights</h2>
            <p className="text-textMuted">
              Depending on your legal location, you maintain specific rights regarding your personal data, including the right to request access to, correction of, or deletion of the data we hold on your account.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">7. Changes to This Policy</h2>
            <p className="text-textMuted">
              We reserve the right to update this Privacy Policy from time to time. We will indicate changes by updating the revision date at the top of this document. Continued usage of the Service implies compliance with the revised policies.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">8. Governing Law</h2>
            <p className="text-textMuted">
              This Privacy Policy is governed by and construed in accordance with the laws of England.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">9. Contact Us</h2>
            <p className="text-textMuted">
              If you have questions or concerns regarding this policy, please reach out to our team at deciphertextco@gmail.com.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}